export default {
  computed: {
    showClearSourceVideoModal() {
      return localStorage.getItem('ME:studio-ai:showClearSourceVideoModal') !== 'false';
    },
  },
};
